module.exports = __webpack_public_path__ + "img/komura.8568d661.svg";